import React from 'react';
import { format } from 'date-fns';
import { useFetch, PseudoStates, PageTitle } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import NotesForm from '~/components/Note/Form';

const NotesDetails = () => {
  const params = useParams();
  const [status, data] = useFetch(`/notes/${params.note_id}`);

  return status === 'success' ? (
    <>
      <PageTitle>{`${data.attributes.noteType} on ${format(data.attributes.createdDate, 'MM/DD/YY')}`}</PageTitle>

      <NotesForm data={data.attributes} disabled />
    </>
  ) : (
    <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
  );
};

export default NotesDetails;
